/* eslint-disable camelcase */
import axios from "axios";
/**
 * Request company suggestions from the service API.
 */
const fetchCompanySuggestionsPrivate = async (query, config) => {
    const { apiHost, apiRequestTimeoutMs = 5000, appName = "Design System", } = config;
    // if query exists we will pass it in the params.
    const queryObj = query ? { query } : {};
    const reqConfig = { params: Object.assign({ type: "company_name" }, queryObj), timeout: apiRequestTimeoutMs };
    const path = `${apiHost}/api/v2/suggestions`;
    try {
        const response = await axios(path, reqConfig);
        return response.data;
    }
    catch (error) {
        console.error(`Design System was unable to request company suggestions from ${path}`, JSON.stringify(error));
        return null;
    }
};
/**
 * Request company suggestions.
 */
const fetchCompanySuggestionsPublic = async (inputValue, config) => {
    const { apiPath, appName = "Design System", axiosOptions, } = config;
    const path = `${apiPath}/${inputValue}`;
    try {
        const response = await axios(path, Object.assign({ timeout: 5000 }, axiosOptions));
        return response.data;
    }
    catch (error) {
        console.error(`${appName} was unable to request company suggestions from ${path}`, JSON.stringify(error));
        return null;
    }
};
/**
 * Create mock API response.
 */
const mockCompanySuggestorResults = (suggestions) => {
    return suggestions.map((text) => ({
        object: "suggestion",
        type: "company_name",
        text,
        value: {
            object: "company_name_suggestion",
            short_name: text.toLowerCase().replace(/\s+/g, "_"),
        },
        image: "",
    }));
};
export { fetchCompanySuggestionsPrivate, fetchCompanySuggestionsPublic, mockCompanySuggestorResults, };
//# sourceMappingURL=companySuggestions.js.map